/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {Checkbox, Icon, message} from 'antd'

import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Select from 'react-select'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class ProductsDepot extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sellerId: '',
      dateMin: null,
      dateMax: null,
      providers: [],
      loading: false,
      report: [],
      countAll: 0,
      pageSize: 10,
      pageNumber: 1,
      sortData: [
        {
          name: 'ردیف',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productTitle',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کد محصول',
          value: 'productId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بارکد محصول',
          value: 'code',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام تامین کننده',
          value: 'sellerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مقدار',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      sortBy: 'sellerName_asc,productTitle_asc'
    }
  }

  convertToStringDate = (date, type) => {
    if (type === 'from') {
      let from = moment(date)
        .startOf('day')
        .toISOString()
      return from
    } else {
      let to = moment(date)
        .endOf('day')
        .toISOString()
      return to
    }
  }

  createFilter = () => {
    let filter = {}
    let {sellerId, dateMin, dateMax, sortBy} = this.state
    let provider = this.state.sellerId

    filter.deliveryDateMin = this.convertToStringDate(dateMin, 'from')
    filter.deliveryDateMax = this.convertToStringDate(dateMax, 'to')
    filter.page = this.state.pageNumber
    filter.size = this.state.pageSize
    if (sellerId !== '') {
      filter.sellerId = provider
    }
    if (sortBy !== '') {
      filter.sortBy = sortBy
    }
    return filter
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport()
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport()
    }
  }

  getProviders = () => {
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          let provider = response.data.object
          for (let i = 0; i < provider.length; i++) {
            provider[i]['value'] = provider[i].providerId
            provider[i]['label'] = provider[i].providerId + ' - ' + provider[i].title
          }
          this.setState({
            providers: response.data.object
          })
        } else {
          this.setState({
            providers: []
          })
        }
      })
      .catch((err) => {})
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getReport = () => {
    let filter = this.createFilter()
    this.setState({
      loading: true
    })
    http
      .get(`warehouse/depot/orders/masters/items`, {
        params: filter
      })
      .then((res) => {
        this.setState({
          report: []
        })
        if (res.data.error == null) {
          this.setState(
            {
              report: res.data.object.productStockTransactionMasters,
              loading: false,
              countAll: res.data.object.count,
              tablePageNumber: this.state.pageNumber
            },
            () => {
              if (this.state.report.length === 0) {
                message.error('هیچ داده ای وجود ندارد')
              }
            }
          )
        } else {
          message.error(response.data.description)
          this.setState({
            loading: false,
            report: []
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    // this.getProviders()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    if (this.state.dateMax === null || this.state.dateMin === null) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport()
        }
      )
    }
  }

  dateMin(props) {
    return <input className="form-control" {...props} />
  }

  dateMax(props) {
    return <input className="form-control" {...props} />
  }

  changeProvider = (sellerId) => {
    this.setState({
      sellerId
    })
  }

  changeDateMin = (dateMin) => {
    this.setState({
      dateMin,
      dateMax: dateMin
    })
  }
  changeDateMax = (dateMax) => {
    this.setState({
      dateMax
    })
  }

  showUnitOfProduct = (item) => {
    if (item.productUnitId === item.productPackageUnitId) {
      return item.sumQuantity + ' ' + item.productUnitTitle
    } else {
      return (
        item.sumPackageQuantity +
        '  ' +
        item.productPackageUnitTitle +
        ' ( ' +
        ' معادل  ' +
        item.sumQuantity +
        '  ' +
        item.productUnitTitle +
        ' ) '
      )
    }
  }

  exportExcel = () => {
    let filter = this.createFilter()
    filter.size = 10000
    filter.page = 1
    http
      .get(`warehouse/depot/orders/masters/items`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          response.data.object.productStockTransactionMasters.forEach((item) => {
            item.itemCount = this.showUnitOfProduct(item)
          })
          this.setState(
            {
              excelReport: response.data.object.productStockTransactionMasters
            },
            () => {
              this._export.save(this.state.excelReport)
            }
          )
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    let {pageNumber, pageSize, loading, date} = this.state

    let printCol = ['ردیف', 'موبایل', 'متن پیام', 'زمان ارسال پیام']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست کالاهای رزرو دپو.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productTitle'}
                field={'productTitle'}
                title={'نام محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productId'}
                field={'productId'}
                title={'کد محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'code'}
                field={'code'}
                title={'بارکد محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sellerName'}
                field={'sellerName'}
                title={'نام تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'itemCount'}
                field={'itemCount'}
                title={'مقدار'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>انبار</li>
            <li>لیست کالاهای رزرو دپو</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.report.length ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label htmlFor="wareType">
                    {' '}
                    تاریخ تحویل به مشتری از
                    <span className="text-danger mx-1">*</span>
                  </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(dateMin) => (dateMin == null ? '' : dateMin.format('jYYYY/jMM/jDD'))}
                      value={this.state.dateMin}
                      onChange={this.changeDateMin}
                      TextFieldComponent={this.dateMin}
                      id="deliveryDateMin"
                      name="deliveryDateMin"
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="formComponent">
                  <label htmlFor="wareType">
                    تاریخ تحویل به مشتری تا
                    <span className="text-danger mx-1">*</span>
                  </label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(dateMax) => (dateMax == null ? '' : dateMax.format('jYYYY/jMM/jDD'))}
                      minDate={this.state.dateMin !== null ? this.state.dateMin : 0}
                      value={this.state.dateMax}
                      onChange={this.changeDateMax}
                      TextFieldComponent={this.dateMax}
                      id="deliveryDateMax"
                      name="deliveryDateMax"
                      readOnly
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.sellerId}
                    setValue={(sellerId) => this.setState({sellerId})}
                  />
                  {/* <label htmlFor="wareType">تامین کننده
                                    </label>
                                    <Select
                                        value={this.state.sellerId}
                                        onChange={this.changeProvider}
                                        options={this.state.providers}
                                        isClearable
                                        placeholder='------'
                                    /> */}
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            {this.state.report.length > 0 && (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  <tbody>
                    {this.state.report.map((item, index) => (
                      <tr key={index}>
                        <td>{(this.state.tablePageNumber - 1) * 10 + index + 1}</td>
                        <td className="align-middle text-left">
                          <a
                            style={{color: 'blue'}}
                            target="_blank"
                            className="btn-link"
                            href={productShop({articleId: item.productId})}
                          >
                            {item.productTitle}
                          </a>
                        </td>
                        <td>{item.productId}</td>
                        <td className="text-center align-middle">{item.code}</td>
                        <td>{item.sellerName}</td>
                        <td className="text-center align-middle">
                          <span>{this.showUnitOfProduct(item)}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumber}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.pageNumber}
                    total={this.state.countAll}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default ProductsDepot
